import { useEffect, useRef, useState } from "react";
import { animate, useReducedMotion } from "framer-motion";

export function CountUp({ value, format = (v) => String(Math.round(v)), duration = 0.6 }) {
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(value || 0);
  const prev = useRef(0);
  useEffect(() => {
    const target = Number(value) || 0;
    if (reduce) { setDisplay(target); prev.current = target; return undefined; }
    const ctrl = animate(prev.current, target, { duration, ease: [0.22, 1, 0.36, 1], onUpdate: setDisplay });
    prev.current = target;
    return () => ctrl.stop();
  }, [value, duration, reduce]);
  return <span>{format(display)}</span>;
}
